import React from 'react';
import { CTAButton } from './CTAButton';
import { OfferLink } from './OfferLink';
import { finalSection, product } from '../data/salesCopy';
export function FinalCTA() {
  return <section className="border-t-4 border-brand-gold bg-brand-sage px-4 py-8 text-brand-ivory sm:py-10" data-id="element-78" data-mp="c6shh8bfls8m">
      <div className="mx-auto max-w-3xl" data-id="element-79" data-mp="85fd72nzlx3t">
        <h2 className="text-center font-serif text-xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-80" data-mp="83m5dk1n16u8">
          {finalSection.heading}
        </h2>
        <span className="mx-auto mt-2 block h-0.5 w-14 bg-brand-gold" data-id="element-81" data-mp="h6dm9zda8ut9" />

        <p className="mt-4 text-center text-[13px] font-medium text-brand-ivory/85 sm:text-[15px]" data-id="element-82" data-mp="h411leg546ci">
          {finalSection.intro}
        </p>
        <p className="mt-1 text-center font-serif text-lg italic text-brand-sand sm:text-2xl" data-id="element-83" data-mp="qwq1rd68pxsj">
          {finalSection.quote}
        </p>

        <ul className="mt-4 grid gap-1 sm:grid-cols-2" data-id="element-84" data-mp="14tdbyhn7ekge">
          {finalSection.keeps.map(line => <li key={line} className="rounded border border-white/15 bg-brand-sageDark/50 px-2.5 py-1.5 text-[12px] font-medium leading-snug text-brand-ivory/80 sm:text-[13px]" data-id="element-85" data-mp="zua8h1mvgmaj">
              {line}
            </li>)}
        </ul>

        <p className="mt-4 text-center font-serif text-base font-extrabold uppercase text-brand-gold sm:text-xl" data-id="element-86" data-mp="2m1j5v4ghenf7">
          {finalSection.or}
        </p>

        <ol className="mt-3 flex flex-wrap justify-center gap-1.5" data-id="element-87" data-mp="2v424tdh5cfw6">
          {finalSection.steps.map(step => <li key={step} className="rounded border border-brand-sand/50 bg-white/10 px-2.5 py-1 text-[12px] font-bold text-white sm:text-[13px]" data-id="element-88" data-mp="301k9gro4s8yd">
              {step}
            </li>)}
        </ol>

        <div className="mt-6 grid items-center gap-4 sm:grid-cols-[180px_1fr]" data-id="element-89" data-mp="39u9k5kbuxisn">
          <OfferLink className="block" data-id="element-90" data-mp="3epf104qek79v">
            <img src={product.image} alt="YIN YOGA READY™ box set" className="mx-auto w-full max-w-[180px] drop-shadow-2xl transition-transform duration-200 ease-smooth hover:scale-[1.02]" data-id="element-91" data-mp="3islf1yjrb2qw" />
          </OfferLink>

          <div className="text-center sm:text-left" data-id="element-92" data-mp="1enfh04oiibwm">
            <p className="font-serif text-2xl font-extrabold uppercase leading-none text-white sm:text-3xl" data-id="element-93" data-mp="1shovcy2z1ibv">
              🧘 {product.name}
            </p>
            <p className="mt-1 text-[11px] font-extrabold uppercase tracking-[0.15em] text-brand-sand sm:text-xs" data-id="element-94" data-mp="22eumg6bl59c3">
              {product.tagline}
            </p>
            <p className="mt-1 text-[11px] font-semibold text-brand-ivory/75 sm:text-xs" data-id="element-95" data-mp="1xf8dwa6pch9m">
              {product.stripShort}
            </p>
            <p className="mt-3 text-[11px] font-extrabold uppercase tracking-widest text-brand-gold sm:text-xs" data-id="element-96" data-mp="27e79os6dcif7">
              🔥 Get the complete system today
            </p>
            <div className="mx-auto mt-2 max-w-md" data-id="element-97" data-mp="h3kur91vovxu">
              <CTAButton subLabel="Immediate Access • Digital Delivery" data-id="element-98" data-mp="d0y95pvsw793">
                🧘 YES! I WANT YIN YOGA READY™
              </CTAButton>
            </div>
            <p className="mt-2 text-center text-[11px] font-bold text-brand-ivory/80 sm:text-left sm:text-xs" data-id="element-99" data-mp="6xjtpgnz588u">
              🛡️ 14-Day Money-Back Guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}